import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/timer';
import { connect } from 'react-redux';
import Headbar from './headbar.jsx';
import Projectbarchart from './projectBarChart.jsx'
import Recordsofday from './recordsofday.jsx'
import Thisweektime from './thisWeekTime.jsx'
import { listToDay } from '../api/timeListProcess'

class Timerpage extends Component {

  constructor(props){
    super(props);
    this.recordList = [];
  }

  initComp(props, state){
    if(props.timer.records.list){
      const records = listToDay(props.timer.records.list)
      this.recordList = [];
      for( let date in records ){
        this.recordList.push(
          <Recordsofday startSameRecord={this.props.startSameRecord} deleteRecord={this.props.deleteRecord} updateRecord={this.props.updateRecord} key={date} date={date} times={records[date]} />
        )
      }
    }
  }

  

  componentWillMount(){
    this.initComp(this.props, this.state)
  }

  componentWillReceiveProps(nextProps, nextState){
    this.initComp(nextProps, nextState)
  }

  render() {
    return (
      <div className='timerpage-body'>
        <Headbar {...this.props} />
        <Thisweektime recordsDuration={ this.props.timer.records_total_duration } />
        <Projectbarchart currentWeek={ this.props.timer.currentWeek } />
        { this.recordList }
      </div>
    );
    
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
    timer: state.timer
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Timerpage);